import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
    const locales = require.context(
        "@/locales",
        true,
        /[A-Za-z0-9-,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1].split("_")[0];
            if ( ! (locale in messages) ) {
                messages[locale] = {};
            }
            messages[locale] = { ...messages[locale], ...locales(key) } ;
        }
    });
    return messages;
}

// Valid language codes
const VALID_LOCALES = ['en', 'de', 'fr'];
const DEFAULT_LOCALE = 'en';

// Helper function to validate and get a valid locale
function getValidLocale(locale) {
    return VALID_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
}

// Get initial locale, ensuring it's valid
const browserLocale = navigator.language.split("-")[0];
const envLocale = process.env.VUE_APP_I18N_LOCALE;
let locale = getValidLocale(envLocale || browserLocale || DEFAULT_LOCALE);

const fallbackLocale = DEFAULT_LOCALE;


export default new VueI18n({
    locale,
    fallbackLocale,
    messages: loadLocaleMessages(),
});
